import React, { Component, useState } from 'react'
import HiringCard from '../Hiring/HiringCard.jsx'
import './HomePlateform.css'
import HomeLocalKPI from './HomeLocalKPI'
import HomePartnersBlogs from './HomePartnersBlogs'
import HomePartnersArticles from './HomePartnersArticles.js'
import HomeToolboxPartnersCarousel from './HomeToolboxPartnersCarousel'
import HomeMonthHotel from './HomeMonthHotel'
import HomeFooter from './HomeFooter'
import OpenWeather from '../OpenWeather/OpenWeather'
import HomeVideo from "../HomeVideo/HomeVideo"
import { ReactComponent as HiringIcon } from '../../Assets/img/home-page/hiring-icon.svg'
import { ReactComponent as HimmoIcon } from '../../Assets/img/home-page/himmo-icon.svg'
import { ReactComponent as BlogIcon } from '../../Assets/img/home-page/blog-icon.svg'
import LinkedinColorIcon from '../../Assets/img/icon/linkedin-color.svg'
import LinkedinIcon from '../../Assets/img/icon/linkedin.svg'
import YoutubeIcon from '../../Assets/img/icon/youtube.svg'
import { globals } from '../Globals/Globals'
import { useDispatch, useSelector } from 'react-redux'

import { logout } from '../../redux/authSlice'
import {revertAll} from "../../redux/hotelSlice.js"
import {revertAllStats } from '../../redux/statSlice';
import {revertAllArticles } from '../../redux/articleSlice';
import {revertAllHirings } from '../../redux/hiringSlice';
import {revertAllAwards} from "../../redux/awardSlice"
import {revertAllToolboxPartners} from "../../redux/toolboxPartnerSlice"
import {revertAllVideos} from "../../redux/videoSlice"
import {revertAllParams} from "../../redux/paramSlice"
import {openModalHiringContact} from "../../redux/modalSlice"
import StickyMenu3 from '../StickyMenu3/StickyMenu3'
import WixBlogRSS from '../../Components/WixBlog/WixBlogRSS.jsx'

const HomePage = () => {
    let dispatch = useDispatch();
    const [uniquePage, setUniquePage] = useState(false)
    const {hiringsItems} = useSelector((state) => state.hirings)
    const {articlesItems} = useSelector((state) => state.articles)
    const {hotelsItems} = useSelector((state) => state.hotels)

    // Select 3 random hotel items from the list
    const hotelsSample = (hotelsItems || []).slice().sort(() => Math.random() - 0.5).slice(0, 3);

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        var navigationType = (window.performance.getEntriesByType("navigation")[0]).type;
        if (globals.parameters.debugging)
            console.log("navigationType->", navigationType)

        //back_forward value is duplicate tab
        if(navigationType == 'back_forward'){
            console.log("Page is duplicated")
            setUniquePage(false)
            
            window.open("https://www.lecercle-hotels.com/adh%C3%A9rer-nousrejoindre", "_self")
            /*
            window.close();
            dispatch(openModal({title:"Une page est déjà ouverte !"}));*/
            alert ("HotelHub 360 est déjà ouverte dans ce navigateur ! Vous serez redirigés vers Le Cercle...")
        }
        else setUniquePage(true)

        {/**---- Detect Page reload with F5 */}
/*
        if (window.performance) {
            if (performance.navigation.type == 1) {
                alert( "This page is reloaded" );
            } else {
                alert( "This page is not reloaded");
            }
        }
            */
        if (navigationType == "reload") {
            if (globals.parameters.debugging)
                console.log( "This page is reloaded" );
            //Purge local IndexedDB cache
            dispatch(logout());
            dispatch(revertAll());
            dispatch(revertAllStats());
            dispatch(revertAllArticles());
            dispatch(revertAllHirings());
            dispatch(revertAllAwards()); 
            dispatch(revertAllToolboxPartners());
            dispatch(revertAllVideos());
            dispatch(revertAllParams());

            if (globals.parameters.debugging)
                console.log("Database purge done !")
        } else {
            if (globals.parameters.debugging)
                console.log( "This page is not reloaded");
        }
        
                
        // Cleanup function
        return () => {
            console.log("Cleaning persistent context...")
            //Let us clean persistant local database
            dispatch(logout());
            dispatch(revertAll());
            dispatch(revertAllStats());
            dispatch(revertAllArticles());
            dispatch(revertAllHirings());
            dispatch(revertAllAwards()); 
            dispatch(revertAllToolboxPartners());
            dispatch(revertAllVideos());
            dispatch(revertAllParams());
            isMounted = false
        }
    }, []);
          
    return(
        <>
            {uniquePage &&
            <div className="container-grid">
                {globals.parameters.whatsapp &&
                <a
                    href="https://wa.me/1234567890?text=Hello%20from%20my%20React%20app!"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    Chat with us on WhatsApp
                </a>}
                <StickyMenu3 auto_padding={true}/>
                <div className="main-layout-container">
                    <div className="main-content-sections">
                        <div class="row-stats-weather">
                            <HomeLocalKPI fallback_picture={globals.dico.analytics_fallback_picture}/>
                            <OpenWeather/>
                        </div>

                        <div class="row-container green">
                            <div className='title-corner-container'>
                                <div className='title-corner white'/>
                            </div>

                            <div className='row-title'>Actualité des membres</div>

                            <div className='title-hyphen-container'>
                                <div className='title-hyphen white'/>
                            </div>

                            <div className='row-actualite'>
                                <HomeMonthHotel 
                                    title="Les hôtels du mois"
                                    />
                                <div id="home-month-video"
                                    style={{width:`${"25%"}`}}
                                    >
                                    <HomeVideo video_index={0}/>
                                </div>
                                <div id="home-month-video"
                                    style={{width:`${"25%"}`}}
                                    >
                                    <HomeVideo video_index={1}/>
                                </div>
                            </div>
                        </div>

                        <div class="row-container white">
                            <div className='title-corner-container'>
                                <div className='title-corner green'/>                        
                            </div>

                            <div className='row-title'>Les News</div>

                            <div className='title-hyphen-container'>
                                <div className='title-hyphen green'/>
                            </div>

                            <div class="row-blog">
                                <HomePartnersArticles article_index={0}/>
                                <HomePartnersArticles article_index={1}/>
                                <HomePartnersArticles article_index={2}/>
                            </div>
                        </div>
                    </div>

                    <div className="unified-right-aside">
                        <div className="aside-section community-aside">
                            <h6>Rejoignez le cercle des passionnés de l'hôtellerie :</h6>
                            <div className="aside-content">
                                <p className="community-subtitle">Échangez, innovez et grandissez avec nous !</p>
                                <div className="community-row">
                                    <div className="community-copy">
                                        <div className="community-divider"/>
                                        <ul className="community-benefits">
                                            <li>Un espace d'entraide</li>
                                            <li>Des opportunités d'affaires</li>
                                            <li>Une veille sectorielle</li>
                                            <li>Des ressources exclusives</li>
                                        </ul>
                                    </div>
                                    <div className="community-socials">
                                    <a aria-label="LinkedIn" className="social-link linkedin" href="#" onClick={(e)=>{e.preventDefault(); window.open(globals.links.linked_in, '_blank', 'noopener,noreferrer')}}>
                                        <img src={LinkedinIcon} alt="LinkedIn" className="social-svg" />
                                    </a>
                                    <a aria-label="Site" className="social-link site" href="#" onClick={(e)=>{e.preventDefault(); window.open(globals.links.le_cercle, '_blank', 'noopener,noreferrer')}}>
                                        <img src={LinkedinColorIcon} alt="Site" className="social-svg" />
                                    </a>
                                    <a aria-label="Facebook" className="social-link facebook" href="#" onClick={(e)=>{e.preventDefault(); window.open(globals.links.facebook, '_blank', 'noopener,noreferrer')}}>
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a aria-label="YouTube" className="social-link youtube" href="#" onClick={(e)=>{e.preventDefault(); window.open(globals.links.youtube, '_blank', 'noopener,noreferrer')}}>
                                        <img src={YoutubeIcon} alt="YouTube" className="social-svg" />
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="aside-section wix-blog-aside">
                            <div className="wix-blog-header">
                                <BlogIcon className="blog-icon" aria-hidden="true" />
                                <h5>BLOG</h5>
                            </div>
                            <div className="aside-content">
                                {false &&<WixBlogRSS 
                                    siteUrlOLD="https://monsite.wixsite.com/monblog"
                                    siteUrl="https://www.lecercle-hotels.com/blog-feed.xml"
                                    maxPosts={10}
                                />}
                                <div className="wix-blog-list">
                                    <HomePartnersBlogs blog_index={0}/>
                                    <HomePartnersBlogs blog_index={1}/>
                                    <HomePartnersBlogs blog_index={2}/>
                                </div>
                            </div>
                        </div>

                        <div className="aside-section himmo-aside">
                            <div className="himmo-immo-header">
                                <HimmoIcon className="himmo-icon" aria-hidden="true" />
                                <h5>Hôtels à vendre / Transmission</h5>
                            </div>
                            <div className="aside-content">
                                <div 
                                    className="wix-immo-list"
                                    onClick={() => window.open('https://hotels.immo', '_blank', 'noopener,noreferrer')}
                                >
                                    {hotelsSample.map((hotelItem, idx) => {
                                        const hotel_name = hotelItem?.data_blob?.data_tier?.Hotel_name || "Titre d'article";
                                        const stars = hotelItem?.data_blob?.data_tier?.stars || "0";
                                        const pictureURL = hotelItem?.data_blob?.data_tier?.hotel_main_picture || globals.dico.partners_fallback_picture;
                                        const link = hotelItem?.data_blob?.data_tier?.article_link || '#';
                                        return (
                                            <div key={hotelItem?.data_guid || idx} className="wix-immo-item">
                                                <img className="wix-immo-thumb" src={pictureURL} alt={hotel_name}/>
                                                <div className="wix-immo-meta">
                                                    <div className="wix-immo-title" onClick={()=> link !== '#' && window.open(link, '_blank', 'noopener,noreferrer')}>{hotel_name}</div>
                                                    <div className="wix-immo-desc">{stars}*</div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                        <div className="aside-section hiring-aside">
                            <div className="hiring-header">
                                <HiringIcon className="blog-icon" aria-hidden="true" />
                                <h4>Offres/Demandes d'emploi</h4>
                            </div>
                                <div className="aside-content">
                                    <div className="hiring-list">
                                        {hiringsItems.map((job, idx) => (
                                            <div 
                                                key={idx} 
                                                className="hiring-item"
                                                style={{cursor: "pointer"}}
                                                onClick={() => dispatch(openModalHiringContact({hiring_data_guid: job, read_only: false}))}
                                            >
                                                <HiringCard
                                                    title={job.data_blob.data_tier.hiring_title}
                                                    salaryRange={job.data_blob.data_tier.hiring_salary}
                                                    location={job.data_blob.data_tier.hiring_location}
                                                    contractType={job.data_blob.data_tier.hiring_contract}
                                                    hiringType={job.data_blob.data_tier.hiring_type}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                        </div>
                        
                        
                    </div>
                </div>

                <div class="row-partners">
                    <HomeToolboxPartnersCarousel/>
                </div>
                
                <div class="row-footer"><HomeFooter/></div>
            </div>}
        </>
    )
} 

export default HomePage;